export default {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.svg#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }